import { render } from "./pageComponent.vue?vue&type=template&id=1910e602&scoped=true"
import script from "./pageComponent.vue?vue&type=script&lang=js"
export * from "./pageComponent.vue?vue&type=script&lang=js"

import "./pageComponent.vue?vue&type=style&index=0&id=1910e602&scoped=true&lang=css"

import exportComponent from "E:\\develop\\company\\gw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1910e602"]])

export default __exports__